"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarkerPosition = void 0;
const getMarkerPosition = (rate, minSlider, maxSlider) => {
    if (rate >= minSlider && rate <= maxSlider) {
        return rate;
    }
    if (rate < minSlider) {
        return minSlider;
    }
    return maxSlider;
};
exports.getMarkerPosition = getMarkerPosition;
